<template>
	<HeaderBlock title="You" />
	<CustomerLoadWait :customer="customer" />
	<transition>
		<div v-if="customer">
			<v-row v-if="!customer.person.whatsAppEnabled">
				<v-col>
					<AdButton title="Whatsapp" @click="openWhatsAppDrawer" subtitle="Enable Whatsapp to chat with us about your finances &amp; send in your documents for automatic processing!"
					:topicon="require('@/assets/Whatsapp.webp')" :bottomrighticon="require('@/assets/go.png')" />
				</v-col>
			</v-row>
			<!-- <v-row>
				<v-col>
					<InfoPanel :blur="true" :icon="require('@/assets/coins.png')" title="Cashback" subtitle="Money back on spending" valueTitle="May 2024" value="£32.50" />
				</v-col>
			</v-row> -->
			<transition>
				<v-row v-if="points && showPoints">
					<v-col>
						<InfoPanel href="/#/Points" valueHref="/#/Leaderboard" :icon="require('@/assets/points.png')" title="MG Points" subtitle="Use the app to earn MG Points" valueTitle="Points" :value="points.points" />
					</v-col>
				</v-row>
			</transition>
			<transition>
				<v-row v-if="financialFitness">
					<v-col>
						<InfoPanel href="/#/FinancialFitness" valueHref="/#/FinancialFitnessHistory" :icon="require('@/assets/financialFitnessIcon.png')" title="My Financial Fitness" subtitle="Take the survey" valueTitle="Score" :value="financialFitness.score" />
					</v-col>
				</v-row>
			</transition>
			
			<transition>
			<v-row v-if="!financialFitness">
				<v-col>
					<InfoPanel href="/#/FinancialFitness" valueHref="/#/FinancialFitness" :icon="require('@/assets/financialFitnessIcon.png')" title="My Financial Fitness" subtitle="Let's calculate your baseline" valueTitle="Score" value="-" />
				</v-col>
			</v-row>
			</transition>

			<transition>
			<v-row v-if="this.customer">
				<v-col>
					<AdButton title="Switch" :href="'https://moneyguided.aptap.co.uk?p1=' + this.customer.person.email + '&p2=' + (this.customer.person.addresses.length > 0 ? this.customer.person.addresses[0].postCode : '')" subtitle="Move to a better Broadband, SIM, Mobile or Energy deal" 
					:topicon="require('@/assets/switch.png')" :bottomrighticon="require('@/assets/go.png')" />
				</v-col>
				<!-- <v-col>
					<AdButton href="MG_POP.html?view=appscreen-Home-Resources-Marketplace" title="Marketplace" subtitle="Financial services" 
					:topicon="require('@/assets/switch.png')" :bottomrighticon="require('@/assets/family.png')" />
				</v-col> -->
			</v-row>
			</transition>

			<transition>
			<v-row v-if="benefits && benefits.length > 0">
				<v-col>
					<ScrollThumbBlock href="/#/Benefits" :title="employer ? employer.name + ' Benefits': 'Employee Benefits'" subtitle="View your employee benefits" :thumbs="benefits" :rightimage="require('@/assets/arrow-right.png')"/>
				</v-col>
			</v-row>
			</transition>

			<transition>
			<v-row v-if="marketplace">
				<v-col>
					<ScrollThumbBlock href="/#/Marketplace" title="Marketplace" subtitle="Explorer deals with our partners" :thumbs="marketplace" :rightimage="require('@/assets/arrow-right.png')"/>
				</v-col>
			</v-row>
			</transition>
			
			<!-- <v-row>
				<v-col><PayRiseCalculator :api="api"/></v-col>
			</v-row> -->
			<v-row>
				<!-- <v-col>
					<CountBlock :href="!cripple ? '/#/CompletedMoves' : null" title="Moves completed" :value="customer.facts['M_COMPLETED'] ?? '0'"></CountBlock>
				</v-col> -->
				<!-- <v-col>
					<CountBlock href="/#/Guides" title="Guides you've read" :value="customer.facts['CMS_READ'] ?? '0'" :subvalue="'of ' + customer.facts['CMS_UNREAD']"></CountBlock>
				</v-col> -->
			</v-row>
			<!-- <v-row>
				<v-col>
					<CountBlock :href="!cripple ? '/#/aiop' : null" title="Accounts" :value="customer.facts['B_ACCOUNTS'] ?? '0'"></CountBlock>
				</v-col>
				<v-col>
					<CountBlock href="MG_POP.html?view=appscreen-Home-Spending" title="Transactions tagged" :value="customer.facts['B_TAGGEDTRANSACTIONS'] ?? '0'"></CountBlock>
				</v-col>		
			</v-row> -->
			<v-row >
				<v-col>
					<AdButton href="/#/CompletedMoves" :topicon="require('@/assets/bullet-tick.png')" :bottomrighticon="require('@/assets/go.png')" subtitle="Review all your completed Moves" title="Completed Moves"></AdButton>
				</v-col>
			</v-row>
			<v-row >
				<v-col>
					<AdButton href="/#/allnotifications" :topicon="require('@/assets/bell.svg')" :bottomrighticon="require('@/assets/go.png')" subtitle="Review your notifications" title="Notifications"></AdButton>
				</v-col>
			</v-row>
			
		</div>
	</transition>

	
	<DrawerPanel v-if="blueLight" ref="blcDrawer" :bottom="_peekingDrawerBottom()" title="Blue Light Card" backgroundColor="white" openBackgroundColor="white">
		<img style="width:100%" :src="blueLight.url" />
	</DrawerPanel>
	<div v-if="blueLight" style="height: 60px"></div>

	<WhatsAppEnableDrawer
		ref="whatsAppEnableDrawer"
		@enable="handleEnableWhatsApp"
		@done="handleWhatsAppEnableDone"
		@closed="handleWhatsAppDrawerClosed"
	/>
</template>

<script>
import Services from '../mixins/Services';
import WhatsAppMixin from '../mixins/WhatsAppMixin';
import InfoPanel from './elements/InfoPanel.vue';
import ScrollThumbBlock from './elements/ScrollThumbBlock.vue';
import AdButton from './elements/AdButton.vue';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import Helpers from '../mixins/Helpers';
import DrawerPanel from './elements/DrawerPanel.vue';
import WhatsAppEnableDrawer from './elements/WhatsAppEnableDrawer.vue';

export default {
	mixins: [Services, Helpers, WhatsAppMixin],
	components: {HeaderBlock, InfoPanel, ScrollThumbBlock, AdButton, CustomerLoadWait, DrawerPanel, WhatsAppEnableDrawer},
	data() {
		return {
			cripple: true,
			showComingSoon: false,
			whatsappPressed: false,
			thumbs: [],
			blueLight: null,
			showPoints: false
		}
	},
	methods: {
		getCustomer: function(){
			this._getAppConfig();
			this._getCustomer(() => {
				this._getPoints();
				this._getNotifications();
				this._getEmployer(this.customer.employerID);
				this._getLatestFinancialFitness();
				this._getProducts(this.customer.employerID);
				this._getProducts();
				this._getBlueLightCard((blc) => {
					this.blueLight = blc;
				});
			});
			this._checkAndRequestNotifications();
		},
		onLoad: async function() {
			this.getCustomer();
		},
		openWhatsAppDrawer() {
			if (this.$refs.whatsAppEnableDrawer) {
				this.$refs.whatsAppEnableDrawer.openDrawer();
			}
		}
	},
	mounted: function () {
		this.onLoad();
	},
}
</script>

<style scoped>



</style>
